import type { Rectangle } from "@pdfking/renderer"

import type { MetaFile } from "../base/MetaFile"
import type { VirtualFileType } from "../VirtualFileType"
import type { GeneratedFile } from "./GeneratedFile"
import type { RemoteFile } from "./RemoteFile"
import type { SinglePagePdf } from "./SinglePagePdf"

export type SinglePageImage = {
  readonly enum: VirtualFileType.SINGLE_PAGE_IMAGE
  readonly content: GeneratedFile | RemoteFile
  readonly source: SinglePagePdf
  readonly size: Rectangle
} & MetaFile
